/**
 * Создаёт маппер Domain<->DTO c прямым 1:1 отображением.
 * Валидация выполняется Zod-схемами, переданными снаружи.
 * Никакой бизнес-логики внутри — только преобразование и валидация.
 */
export function makeSimpleMapper(opts) {
    const { dtoToDomain, domainToDto, dtoToCreateDto, dtoToCreateDom } = opts;
    return {
        toDomain(dto) {
            try {
                const dom = dtoToDomain(dto);
                return dom;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
        toDto(domain) {
            try {
                const dto = domainToDto(domain);
                return dto;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
        toCreateDto(domain) {
            try {
                const dto = dtoToCreateDto(domain);
                return dto;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
        toCreateDom(dto) {
            try {
                const dom = dtoToCreateDom(dto);
                return dom;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
    };
}
